import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "gfu-media__body gfu-search-form-item__body" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_base_title = _resolveComponent("base-title")
  const _component_base_text = _resolveComponent("base-text")

  return (_openBlock(), _createElementBlock("a", {
    href: $options.urlWithRef,
    class: "gfu-search-form-item gfu-media gfu-link gfu-link--nofx gfu-link--block"
  }, [
    _createVNode(_component_base_image, {
      src: $props.thumbImageUrl,
      alt: $props.title,
      width: "42",
      height: "42",
      class: "gfu-search-form-item__image",
      loading: "lazy"
    }, null, 8 /* PROPS */, ["src", "alt"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_title, {
        as: "h3",
        level: "h6",
        class: "_ffb _line-clamp-1",
        "data-qa": `search-form-results-list-item:${$props.title}`
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.title), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["data-qa"]),
      _createVNode(_component_base_text, {
        as: "div",
        level: "overline",
        class: "_tc--gray _toe"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "subtitle")
        ]),
        _: 3 /* FORWARDED */
      })
    ])
  ], 8 /* PROPS */, _hoisted_1))
}